/* Links inside an FAQ answer, as the editor sees them.

   The stored answer is inline Markdown — `[text](/page)` — because that is
   what the client's Astro site renders. Nobody is expected to type that: the
   editor inserts it, and shows it back as a link rather than as brackets. */

export type AnswerPart = { text: string; href?: string };

const LINK_RE = /\[([^\]\n]+)\]\(([^)\s]+)\)/g;

/** The answer split into plain runs and links, for display. */
export function answerParts(answer: string): AnswerPart[] {
  const out: AnswerPart[] = [];
  let at = 0;
  for (const m of answer.matchAll(LINK_RE)) {
    if (m.index! > at) out.push({ text: answer.slice(at, m.index) });
    out.push({ text: m[1], href: m[2] });
    at = m.index! + m[0].length;
  }
  if (at < answer.length) out.push({ text: answer.slice(at) });
  return out;
}

/* Insert a link over the selection, or at the caret with the page's name as
   its text. Brackets in the link text would end it early, so they go. */
export function insertLink(
  value: string, start: number, end: number, href: string, fallbackText: string,
): { value: string; caret: number } {
  const picked = value.slice(start, end).trim();
  const text = (picked || fallbackText).replace(/[[\]]/g, '').trim() || href;
  const link = `[${text}](${href})`;
  return { value: value.slice(0, start) + link + value.slice(end), caret: start + link.length };
}
